module.exports = __webpack_public_path__ + "static/og-980ed7d70de9c962bcfb88b36aac30cb.png";